import * as React from 'react';
import styled from 'styled-components';
import { DsiInput } from '../General/Input';
import { rem } from 'polished';

export interface Props {
  name?: string;
  type?: string;
  placeholder?: string;
  value: string;
  onChange: any;
}

function SearchFormInput(props) {
  return <StyledInput {...props} />;
}

const StyledInput = styled(DsiInput)<{ isMobile?: boolean }>`
  padding: ${rem(16)} ${rem(32)} ${rem(16)} ${rem(52)};
  max-width: 100%;
  width: 100%;
  margin: 0 auto;
  height: ${rem(56)};

  ${({ theme }) => theme.media(0, 'sm')} {
    width: 100%;
    font-size: 14pt;
    line-height: 18pt;
  }

  ${({ theme }) => theme.media('sm')} {
    font-size: ${rem(16)};
    line-height: ${rem(20)};
    padding-top: ${rem(16)};
    padding-bottom: ${rem(16)};
    font-weight: 400;
  }
`;

export { SearchFormInput };
